import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { getActiveBarberId } from '../../sale/selectors';
import ReaderlessChargeButton from '../components/ReaderlessChargeButton';
import { activeShopReaderlessPos, activeShopWebreader, isApiReaderEnabledForShop } from '../../../auth/selectors';
import { hasCardReader } from '../../../main/selectors';
import { getIsFetching } from '../reducer/isFetching/selectors';
import withAddPayment from '../hoc/withAddPayment';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import ReaderChargeButton from '../components/ReaderChargeButton';
import { PAYMENT_TYPE } from '../../../main/payment/constants';
import { getPayments, getHasReaderPayment } from '../reducer/payments/selectors';
import { getHasPaymentOpened } from '../reducer/currentPayment/selectors';

const ReaderChargeButtonContainer = compose(
  withAddPayment,
  connect(
    (state) => {
      const isReaderless = activeShopReaderlessPos(state);
      const hasReader = (
        isReaderless || hasCardReader(state, getActiveBarberId(state)) || activeShopWebreader(state)
      );
      const hasApiReaderEnabled = isApiReaderEnabledForShop(state);
      const hasReaderLoaded = hasApiReaderEnabled || !!window.StripeTerminal;

      return {
        isReaderless,
        disabled: !hasReader || !hasReaderLoaded
          || getHasReaderPayment(state) || getIsFetching(state) || getHasPaymentOpened(state),
        chargeAmount: getChargeAmount(state),
        payments: getPayments(state),
      };
    },
  ),
  withHandlers({
    onClick: props => () => props.addPayment({
      type: props.isReaderless ? PAYMENT_TYPE.readerless : PAYMENT_TYPE.reader,
      amount: props.chargeAmount,
    }),
  }),
  branch(
    props => props.isReaderless,
    renderComponent(ReaderlessChargeButton)
  )
)(ReaderChargeButton);

export default ReaderChargeButtonContainer;
